require("channels");
require("jquery");

import UJS from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";

UJS.start();
ActiveStorage.start();
